<template>
  <v-sheet class="text-center d-flex flex-column align-center bg-background text-on-surface-variant" width="100%">
    <span class="title font-weight-bold mb-3 mt-2">{{ $t('component.helpClaim.claimNotice') }}</span>
    <v-btn class="mt-auto bottom-btn white--text" color="primary" x-large @click="report()">
      {{ $t('component.helpClaim.contactVelo') }}
    </v-btn>
  </v-sheet>
</template>
<script>
  export default {
    methods: {
      report () {
        window.open('https://wa.me/message/GFNCQXWCR25ZN1', '_blank')
      },
    },
  }
</script>
<style scoped>
span {
  font-weight: 300;
}
b {
  font-weight: bold;
}
</style>
